import { render } from "./DistributorServiceProductsSettings.vue?vue&type=template&id=548024bb&scoped=true"
import script from "./DistributorServiceProductsSettings.vue?vue&type=script&lang=js"
export * from "./DistributorServiceProductsSettings.vue?vue&type=script&lang=js"

import "./DistributorServiceProductsSettings.vue?vue&type=style&index=0&id=548024bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548024bb"]])

export default __exports__